import {Subject} from 'rxjs';

export const storeAdapter$ = new Subject()
